import { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AppProviders from "./AppProviders";
import Auth0ProviderWithHistory from "./auth0Provider";
import ErrorBoundary from "./ErrorBoundary";
import CommandPalette from "./CommandPalette";
import AppSpinner from "./ui/AppSpinner";
import { AUTH_OR_DEV_LOGIN_ENABLED } from "./config";

/** Lazy pages */
const VippsLoggedIn = lazy(() => import("./landingpage/VippsLoggedIn"));
const FeideLoggedIn = lazy(() => import("./landingpage/FeideLoggedIn"));
const TermsPage = lazy(() => import("./public/TermsPage"));
const PrivacyPage = lazy(() => import("./public/PrivacyPage"));
const CookiesPage = lazy(() => import("./public/CookiesPage"));
const AccessibilityPage = lazy(() => import("./public/AccessibilityPage"));
const ContactPage = lazy(() => import("./public/ContactPage"));
const StudentGateLogin = lazy(
  () => import("./authentication/StudentGateLogin"),
);
const AppContent = lazy(() => import("./AppContent"));

export default function App() {
  return (
    <Router>
      <a href="#main-content" className="skip-to-content">
        Hopp til hovedinnhold
      </a>
      <CommandPalette />
      <Auth0ProviderWithHistory>
        <AppProviders>
          <ErrorBoundary>
            <Suspense fallback={<AppSpinner />}>
              <Routes>
                {/* Public */}
                <Route path="/login" element={<Navigate to="/elev" replace />} />
                <Route
                  path="/vipps/vipps-logged-in"
                  element={
                    AUTH_OR_DEV_LOGIN_ENABLED ? (
                      <VippsLoggedIn />
                    ) : (
                      <Navigate to="/" replace />
                    )
                  }
                />
                <Route
                  path="/feide/callback"
                  element={
                    AUTH_OR_DEV_LOGIN_ENABLED ? (
                      <FeideLoggedIn />
                    ) : (
                      <Navigate to="/" replace />
                    )
                  }
                />
                <Route path="/elev" element={<StudentGateLogin />} />
                <Route path="/369/login" element={<Navigate to="/elev" replace />} />
                <Route path="/369/admin" element={<Navigate to="/admin" replace />} />

                {/* Public legal and transparency pages */}
                <Route path="/personvern" element={<PrivacyPage />} />
                <Route path="/cookies" element={<CookiesPage />} />
                <Route path="/vilkar" element={<TermsPage />} />
                <Route
                  path="/tilgjengelighet"
                  element={<AccessibilityPage />}
                />
                <Route path="/kontakt" element={<ContactPage />} />
                <Route
                  path="/privattimer"
                  element={<Navigate to="/kontakt" replace />}
                />

                {/* Legacy aliases */}
                <Route
                  path="/privacy-policy"
                  element={<Navigate to="/personvern" replace />}
                />
                <Route
                  path="/terms-of-service"
                  element={<Navigate to="/vilkar" replace />}
                />
                <Route
                  path="/about-us"
                  element={<Navigate to="/kontakt" replace />}
                />
                <Route
                  path="/contact"
                  element={<Navigate to="/kontakt" replace />}
                />
                <Route
                  path="/support"
                  element={<Navigate to="/kontakt" replace />}
                />
                <Route
                  path="/stott"
                  element={<Navigate to="/kontakt" replace />}
                />

                {/* App content */}
                <Route path="/*" element={<AppContent />} />
              </Routes>
            </Suspense>
          </ErrorBoundary>
        </AppProviders>
      </Auth0ProviderWithHistory>
    </Router>
  );
}
